import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import type { EnrichedReadyToSharePlatformPostV2 } from 'src/app/shared/api/readyToShare';

const GROUP_SELECT_MODAL_VIEW_EVENT_NAME = 'petition_manage_ready_to_share_group_select_modal_view';

type UseGroupSelectionTrackingParams = {
	selectedTab: string;
};

type UseGroupSelectionTrackingResult = {
	trackGroupSelection: (post: EnrichedReadyToSharePlatformPostV2) => void;
};

function mapPostToLocation(post: EnrichedReadyToSharePlatformPostV2): 'facebook_group' | 'reddit_group' {
	if (post.platform === 'facebook') {
		return 'facebook_group';
	}
	return 'reddit_group';
}

export function useGroupSelectionTracking({
	selectedTab,
}: UseGroupSelectionTrackingParams): UseGroupSelectionTrackingResult {
	const track = useTracking();

	const trackGroupSelection = useCallback(
		(post: EnrichedReadyToSharePlatformPostV2) => {
			const location = mapPostToLocation(post);
			void track(GROUP_SELECT_MODAL_VIEW_EVENT_NAME, {
				context: 'petition_dashboard_ready_to_share_post',
				view_context: selectedTab,
				location,
			});
		},
		[track, selectedTab],
	);

	return {
		trackGroupSelection,
	};
}
